import { Webcam } from "../../../components/Webcam"
import Viewfinder from "./Viewfinder"
import { CloseIcon, ContentContainer, ScanArea } from "./styled"

interface C2BPushScanProps {
  onQrDetected: (qrData: string) => void
  onClose: () => void
}

const C2BPushScan = ({ onQrDetected, onClose }: C2BPushScanProps) => (
  <ContentContainer>
    <ScanArea>
      <Webcam onQrDetected={onQrDetected} />
      <Viewfinder />
    </ScanArea>
    <CloseIcon
      iconName="close"
      size={23}
      onClick={onClose}
      color="#fff"
    />
  </ContentContainer>
)

export default C2BPushScan
